import React from 'react';
import { GraduationCap, School, Building2 } from 'lucide-react';
import { SlideLayout } from '../SlideLayout';
interface SlideProps {
  isActive: boolean;
  currentSlide: number;
  totalSlides: number;
  onNext: () => void;
  onPrev: () => void;
}
export function ProspectUseCasesSlide(props: SlideProps) {
  return <SlideLayout {...props} title="Built for Every Educator" subtitle="See how different professionals use EduAssess to save time." data-id="element-366">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12" data-id="element-367">
        {/* K-12 */}
        <div className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm flex flex-col h-full" data-id="element-368">
          <div className="w-14 h-14 bg-orange-100 text-orange-600 rounded-2xl flex items-center justify-center mb-6" data-id="element-369">
            <School className="w-8 h-8" data-id="element-370" />
          </div>
          <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-371">
            K-12 Teachers
          </h3>
          <p className="text-slate-500 mb-6 flex-grow" data-id="element-372">
            "I paste the YouTube link for the week's science video, and
            EduAssess generates a 10-question quiz for my Friday class in
            seconds."
          </p>
          <div className="pt-6 border-t border-slate-100" data-id="element-373">
            <div className="text-sm font-bold text-slate-900" data-id="element-374">Result</div>
            <div className="text-orange-600 font-medium" data-id="element-375">
              Saved 4 hours/week
            </div>
          </div>
        </div>

        {/* University */}
        <div className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm flex flex-col h-full relative overflow-hidden" data-id="element-376">
          <div className="absolute top-0 right-0 w-24 h-24 bg-indigo-50 rounded-bl-full -mr-4 -mt-4 z-0" data-id="element-377"></div>
          <div className="w-14 h-14 bg-indigo-100 text-indigo-600 rounded-2xl flex items-center justify-center mb-6 relative z-10" data-id="element-378">
            <GraduationCap className="w-8 h-8" data-id="element-379" />
          </div>
          <h3 className="text-xl font-bold text-slate-900 mb-2 relative z-10" data-id="element-380">
            Professors
          </h3>
          <p className="text-slate-500 mb-6 flex-grow relative z-10" data-id="element-381">
            "I upload my entire semester's lecture notes (PDFs) and generate a
            comprehensive midterm exam with answer keys automatically."
          </p>
          <div className="pt-6 border-t border-slate-100 relative z-10" data-id="element-382">
            <div className="text-sm font-bold text-slate-900" data-id="element-383">Result</div>
            <div className="text-indigo-600 font-medium" data-id="element-384">
              Exam prep done in 10 mins
            </div>
          </div>
        </div>

        {/* Corporate */}
        <div className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm flex flex-col h-full" data-id="element-385">
          <div className="w-14 h-14 bg-emerald-100 text-emerald-600 rounded-2xl flex items-center justify-center mb-6" data-id="element-386">
            <Building2 className="w-8 h-8" data-id="element-387" />
          </div>
          <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-388">
            Corporate Trainers
          </h3>
          <p className="text-slate-500 mb-6 flex-grow" data-id="element-389">
            "We turn our compliance training PPTs into certification assessments
            instantly, ensuring employees actually understood the material."
          </p>
          <div className="pt-6 border-t border-slate-100" data-id="element-390">
            <div className="text-sm font-bold text-slate-900" data-id="element-391">Result</div>
            <div className="text-emerald-600 font-medium" data-id="element-392">
              100% Standardization
            </div>
          </div>
        </div>
      </div>
    </SlideLayout>;
}